import { createAction } from 'redux-act';
import { TLegacyErrors } from '@alycecom/services';
import { createAsyncAction } from '@alycecom/utils';

import {
  IShippingAddress,
  IShippingAddressParams,
  IShippingParams,
  IVerifiedShippingValidation,
} from './shipping.types';

const prefix = 'RECIPIENT/SHIPPING';

export const validateShipping = createAsyncAction<
  IShippingParams,
  IVerifiedShippingValidation,
  TLegacyErrors<IShippingAddress>
>(`${prefix}/VALIDATE`);

export const resetError = createAction<{ name: string }>(`${prefix}/RESET_ERROR`);
export const resetErrors = createAction<void>(`${prefix}/RESET_ERRORS`);
export const resetShipping = createAction<void>(`${prefix}/RESET_SHIPPING`);

export const resetVerification = createAction<void>(`${prefix}/RESET_VERIFICATION`);

export const setManualAddressMode = createAction<boolean>(`${prefix}/SET_MANUAL_ADDRESS_MODE`);

export const fetchShippingAddress = createAsyncAction<IShippingAddressParams, IShippingAddress | null, void>(
  `${prefix}/FETCH_SHIPPING_ADDRESS`,
);
